export const setVehicles = (state, payload) => {
  state.vehicles = payload
}
